import type { ConferenceCatalog } from '../data/schema';

const STORAGE_KEY = 'conference-study:conference-id';

export function conferenceIdForTalk(
  catalog: ConferenceCatalog,
  talkId: string,
): string | undefined {
  return catalog.conferences.find((conference) =>
    talkId.startsWith(`${conference.conferenceId}-`),
  )?.conferenceId;
}

export interface ConferenceSelection {
  readonly currentId: string;
  select(conferenceId: string): void;
}

export function createConferenceSelection(
  catalog: ConferenceCatalog,
  storage: Storage,
): ConferenceSelection {
  const validIds = new Set(
    catalog.conferences.map((conference) => conference.conferenceId),
  );
  let currentId = storage.getItem(STORAGE_KEY) ?? catalog.defaultConferenceId;
  if (!validIds.has(currentId)) currentId = catalog.defaultConferenceId;
  return {
    get currentId() {
      return currentId;
    },
    select(conferenceId) {
      if (!validIds.has(conferenceId)) return;
      currentId = conferenceId;
      storage.setItem(STORAGE_KEY, conferenceId);
    },
  };
}
